import { render, staticRenderFns } from "./compileAndAuthorization.vue?vue&type=template&id=dc8a2d68&scoped=true&"
import script from "./compileAndAuthorization.vue?vue&type=script&lang=js&"
export * from "./compileAndAuthorization.vue?vue&type=script&lang=js&"
import style0 from "./compileAndAuthorization.vue?vue&type=style&index=0&id=dc8a2d68&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8a2d68",
  null
  
)

export default component.exports